// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.item-line {
  display: flex;
  margin: 5px 0;
}
.line-quantity {
  margin-right: 5px;
  font-size: 14px;
}
.line-description {
  font-size: 14px;
  flex-grow: 1;
}
.line-price {
  
}
.final-price {
  font-weight: bold;
}
  `, "",{"version":3,"sources":["webpack://./src/app/services/payment.service.ts"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;;AAEA;AACA;EACE,iBAAiB;AACnB","sourcesContent":["\n.item-line {\n  display: flex;\n  margin: 5px 0;\n}\n.line-quantity {\n  margin-right: 5px;\n  font-size: 14px;\n}\n.line-description {\n  font-size: 14px;\n  flex-grow: 1;\n}\n.line-price {\n  \n}\n.final-price {\n  font-weight: bold;\n}\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
